<template>
  <div class="nextQuestionButtonContainer">
    <div class="imageContainer">
      <img src="@/assets/images/SprocketFoamFinger.png" alt="Pointing hand" class="pointingHand" />
    </div>
    <div class="buttonWrapper">
      <MButton title="Next" @click="nextQuestion">
        <template #right>
          <FontAwesomeIcon :icon="faArrowRight" />
        </template>
      </MButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import MButton from '@/components/MButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const emit = defineEmits<{
  (e: 'next-question-clicked'): void
}>()

const props = defineProps({
  waitingForAnswer: {
    type: Boolean,
    default: false
  },
  backgroundTheme: {
    type: String,
    default: 'light',
    validator: (value: string) => ['light', 'dark'].includes(value)
  }
})

const nextQuestion = () => {
  if (props.waitingForAnswer) {
    emit('next-question-clicked')
  }
}
</script>

<style scoped lang="scss">
.nextQuestionButtonContainer {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  flex-direction: column;

  .imageContainer {
    width: 100px;
    height: 100px;
    position: relative;
    left: 10px; // Offset to the right
    bottom: -10px; // Adjust as needed to position above the button
    z-index: 10;
  }

  .pointingHand {
    width: 100%;
    height: 100%;
    object-fit: contain;
    animation: floating 2s ease-in-out infinite;
  }

  .buttonWrapper {
    animation: buttonPress 2s ease-in-out infinite;
  }
}

@keyframes floating {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes buttonPress {
  0%,
  100% {
    transform: scale(0.98);

    filter: brightness(100%);
  }
  50% {
    transform: scale(1);
    filter: brightness(105%);
  }
}
</style>
